import { render, staticRenderFns } from "./knowledge_add.vue?vue&type=template&id=0c84c451&scoped=true"
import script from "./knowledge_add.vue?vue&type=script&lang=js"
export * from "./knowledge_add.vue?vue&type=script&lang=js"
import style0 from "./knowledge_add.vue?vue&type=style&index=0&id=0c84c451&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c84c451",
  null
  
)

export default component.exports